import React from 'react';
import Top from "../components/Top";
import Blog from "../components/Blog";
import Community from "../components/Community";
import Jobs from "../components/Jobs";
import Directory from "../components/Directory";
import Products from "../components/Products";
import People from "../components/People";

import { Fullpage, HorizontalSlider, Slide } from 'fullpage-react';
const { changeFullpageSlide, changeHorizontalSlide } = Fullpage;

const fullPageOptions = {
  scrollSensitivity: 7,
  touchSensitivity: 7,
  scrollSpeed: 500,
  hideScrollBars: true,
  enableArrowKeys: true
};

const slides = [
  <Slide> <Top /> </Slide>,
  <Slide> <Products /> </Slide>,
  <Slide> <People /> </Slide>,
  <Slide> <Jobs /> </Slide>,
  <Slide> <Community /> </Slide>,
  <Slide> <Blog /> </Slide>
];

const slideNames = [
  "About", "Products", "People", "Jobs", "Community", "Blog"
]

fullPageOptions.slides = slides;


class FullpageReact extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: {
        Fullpage: 0
      }
    };

    this.onSlideChangeStart = this.onSlideChangeStart.bind(this);
    this.onSlideChangeEnd = this.onSlideChangeEnd.bind(this);
  }

  onSlideChangeStart(name, props, state, newState) {
    //
  }

  onSlideChangeEnd(name, props, state, newState) {
    const oldActive = this.state.active;
    const sliderState = {
      [name]: newState.activeSlide
    };

    const updatedState = Object.assign(oldActive, sliderState);
    this.setState(updatedState);
  }

  render() {
    const { active } = this.state;
    const currentActive = active.Fullpage;

    return (
      <div>
        <Directory activeSlide = {this.state.active.Fullpage} numberOfSlides = {slides.length} slideNames = {slideNames} />
        <Fullpage onSlideChangeStart={this.onSlideChangeStart} onSlideChangeEnd={this.onSlideChangeEnd} {...fullPageOptions}>
        </Fullpage>
      </div>
    );
  }
}

export default FullpageReact;



// WEBPACK FOOTER //
// ./src/logic/FullpageModified.js